// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"zp-z","badgeLink":"Ap-z","category":"Bp-z"};